// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3tvwO","name":"ConsentHeader_name__1N9ji","birthday":"ConsentHeader_birthday__39-l3","skeleton":"ConsentHeader_skeleton__2uBzd"};